import { useGetLeagueGamesQuery } from '@bo-services/leaguesApi';

export function useGames({
  fromDate,
  leagueId,
  toDate
}: {
  fromDate?: string;
  leagueId?: string;
  toDate?: string;
}) {
  const {
    data: leagueGames,
    isError: isLeagueGamesError,
    isFetching,
    isLoading
  } = useGetLeagueGamesQuery(
    {
      leagueId,
      fromDate,
      toDate
    },
    { skip: !leagueId }
  );

  const isLeagueGamesLoading = isLoading || isFetching;

  return {
    games: isLeagueGamesError || !leagueGames ? [] : leagueGames,
    isLeagueGamesError,
    isLeagueGamesLoading
  };
}
